import React from "react";

type UserType = "renter" | "vendor" | "admin" | "user";

type RoleProps = {
  className?: string;
  type: UserType;
};

const Role = ({ className, type }: RoleProps): JSX.Element => {
  return (
    <span
      className={`${
        type === "renter"
          ? "bg-green-300"
          : type === "vendor"
          ? "bg-red-300"
          : "bg-purple-300"
      } px-1 py-1 rounded-md mx-1 `}
    >
      {type}
    </span>
  );
};

export default Role;
